import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { SetDefaultShowAPIPage } from './set-default-show-api.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: SetDefaultShowAPIPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [SetDefaultShowAPIPage],
})
export class SetDefaultShowAPIModule {}
